import { render, staticRenderFns } from "./ManaEvo.vue?vue&type=template&id=bcef6b96&scoped=true&"
import script from "./ManaEvo.vue?vue&type=script&lang=js&"
export * from "./ManaEvo.vue?vue&type=script&lang=js&"
import style0 from "./ManaEvo.vue?vue&type=style&index=0&id=bcef6b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcef6b96",
  null
  
)

export default component.exports